var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-spot",style:(_vm.computeStyle),on:{"click":function($event){$event.stopPropagation();return _vm.hotSpotClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }